import Icon from '@/components/ui/AppIcon';

interface ProjectType {
  id: string;
  title: string;
  description: string;
  icon: string;
}

interface ProjectTypeSelectorProps {
  selectedType: string;
  onSelect: (typeId: string) => void;
}

const ProjectTypeSelector = ({ selectedType, onSelect }: ProjectTypeSelectorProps) => {
  const projectTypes: ProjectType[] = [
    {
      id: 'residential',
      title: 'Résidentiel',
      description: 'Appartement ou maison individuelle',
      icon: 'HomeIcon',
    },
    {
      id: 'commercial',
      title: 'Commercial',
      description: 'Bureau, boutique ou espace professionnel',
      icon: 'BuildingOfficeIcon',
    },
    {
      id: 'heritage',
      title: 'Patrimoine',
      description: 'Bâtiment historique ou classé',
      icon: 'BuildingLibraryIcon',
    },
    {
      id: 'investment',
      title: 'Investissement',
      description: 'Propriété locative ou multi-unités',
      icon: 'CurrencyEuroIcon',
    },
  ];

  return (
    <div data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:44:4" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="44" data-component-end-line="71" data-component-file="ProjectTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20gap-4%22%7D" className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {projectTypes.map((type) => (
        <button data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:46:8" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="46" data-component-end-line="69" data-component-file="ProjectTypeSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
          key={type.id}
          type="button"
          onClick={() => onSelect(type.id)}
          className={`p-6 rounded-lg border-2 transition-all duration-300 text-left ${
            selectedType === type.id
              ? 'border-primary bg-light-accent shadow-gold'
              : 'border-border bg-card hover:border-primary-light hover:shadow-subtle'
          }`}
        >
          <div data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:56:10" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="56" data-component-end-line="68" data-component-file="ProjectTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20space-x-4%22%7D" className="flex items-start space-x-4">
            <div data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:57:12" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="57" data-component-end-line="63" data-component-file="ProjectTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`p-3 rounded-lg ${
                selectedType === type.id ? 'bg-primary text-primary-foreground' : 'bg-muted text-secondary'
              }`}
            >
              <Icon data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:62:14" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="62" data-component-end-line="62" data-component-file="ProjectTypeSelector.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={type.icon as any} size={24} />
            </div>
            <div data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:64:12" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="64" data-component-end-line="67" data-component-file="ProjectTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">
              <h3 data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:65:14" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="65" data-component-end-line="65" data-component-file="ProjectTypeSelector.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-lg%20text-text-primary%20mb-1%22%7D" className="font-playfair font-bold text-lg text-text-primary mb-1">{type.title}</h3>
              <p data-component-id="src/app/contact-quote/components/ProjectTypeSelector.tsx:66:14" data-component-path="src/app/contact-quote/components/ProjectTypeSelector.tsx" data-component-line="66" data-component-end-line="66" data-component-file="ProjectTypeSelector.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%22%7D" className="text-sm text-text-secondary">{type.description}</p>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ProjectTypeSelector;